import {
  assignmentKey,
  type PersonnelAssignment,
} from "./matter-personnel-assignment-diff";
import type { Matter } from "@/lib/types";

export function getInitialPersonnelAssignments(
  matter: Matter,
): PersonnelAssignment[] {
  return matter.assignees
    .filter((assignee) => !assignee.dateTimeEnd)
    .map((assignee) => ({
      userId: assignee.user.id,
      roleId: assignee.role.id,
      primaryContact: assignee.primaryContact,
    }));
}

export function getVisiblePersonnelAssignments(
  activeRoster: PersonnelAssignment[],
  assignments: PersonnelAssignment[],
  removedRosterUsers: string[],
  overriddenRoleUsers: string[],
): PersonnelAssignment[] {
  const rosterAssignments = activeRoster
    .filter(
      (member) =>
        !removedRosterUsers.includes(member.userId) &&
        !overriddenRoleUsers.includes(member.userId),
    )
    .map(({ userId, roleId }) => ({ userId, roleId }));
  return [
    ...new Map(
      [...rosterAssignments, ...assignments].map((item) => [
        assignmentKey(item),
        item,
      ]),
    ).values(),
  ];
}

export function orderAssignedPeople(
  assignments: PersonnelAssignment[],
  nameFor: (userId: string) => string,
): string[] {
  return [...new Set(assignments.map((item) => item.userId))].sort(
    (left, right) =>
      nameFor(left).localeCompare(nameFor(right)) || left.localeCompare(right),
  );
}

export function getSuggestedRolesByUserId(
  activeRoster: PersonnelAssignment[],
  initialAssignments: PersonnelAssignment[],
  lastRolesByUserId: Partial<Record<string, string[]>>,
): Map<string, string[]> {
  const suggestions = new Map<string, string[]>();
  for (const item of [...activeRoster, ...initialAssignments]) {
    suggestions.set(item.userId, [
      ...new Set([...(suggestions.get(item.userId) ?? []), item.roleId]),
    ]);
  }
  for (const [userId, roleIds] of Object.entries(lastRolesByUserId)) {
    if (roleIds) suggestions.set(userId, roleIds);
  }
  return suggestions;
}
